
// resources/front/supportnhp/js/components/feedback.js
//
// Vote "Cet article vous a-t-il aidé ?" — polymorphe (type + id).
// - anti-double-vote local via localStorage (par type:id)
// - POST JSON CSRF vers /feedback/vote
//
// Usage (Alpine) :
//   x-data="feedback('post', 303)"
//
export default function feedback(type, id) {
    return {
        type,
        id,
        voted: false,
        loading: false,
        message: '',
        counts: { yes: 0, no: 0, total: 0 },

        init() {
            try {
                const key = 'feedback-' + this.type + ':' + this.id;
                if (localStorage.getItem(key)) {
                    this.voted = true;
                    this.message = 'Merci, votre avis a bien été pris en compte.';
                }
            } catch (e) { /* ignore */ }
        },

        async vote(value) {
            if (this.voted || this.loading) return;
            this.loading = true;

            const tokenMeta = document.querySelector('meta[name="csrf-token"]');
            const headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
            if (tokenMeta) headers['X-CSRF-TOKEN'] = tokenMeta.getAttribute('content');

            try {
                const res = await fetch('/feedback/vote', {
                    method: 'POST',
                    headers,
                    // objet nommé à la racine -> compat filtre CSRF CI4
                    body: JSON.stringify({ type: this.type, id: this.id, vote: value ? 1 : 0 }),
                });
                const data = await res.json();

                if (data.ok) {
                    this.voted = true;
                    this.message = data.message || 'Merci pour votre retour !';
                    if (data.counts) this.counts = data.counts;
                    try {
                        localStorage.setItem('feedback-' + this.type + ':' + this.id, value ? '1' : '0');
                    } catch (e) { /* ignore */ }
                } else {
                    this.message = data.message || 'Une erreur est survenue.';
                }
            } catch (e) {
                this.message = 'Impossible d\'enregistrer votre avis pour le moment.';
            } finally {
                this.loading = false;
            }
        },
    };
}
